"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const mongoose_1 = require("mongoose");
const enum_1 = require("./enum");
const regionSchema = new mongoose_1.Schema({
    name: { type: String, required: true },
    country: { type: String, required: true },
    continent: { type: String, enum: Object.values(enum_1.REGION_CONTINENT) },
    enabled: { type: Boolean, default: false, select: true },
    dbVolumePath: { type: String, required: true }
});
exports.default = (0, mongoose_1.model)("Region", regionSchema, "regions");
